import React, { useState, useEffect, useCallback } from 'react';
import { Container, Row, Col, Card, Button, Badge, Form } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import Utility from '../../../../GlobalModules/Utility/Utility';
import { toast } from "react-toastify";
import { getStockTransferDetails } from "../Controller/StockTransferController";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import ConfirmationAlert from "../../../../GlobalModules/Utility/Components/ConfirmationAlert";
import ModalGlobal from "../../../../GlobalModules/Utility/Components/ModalGlobal";
import ErrorBoundary from "../../../../GlobalModules/Utility/Components/ErrorBoundary";
import VerifyProductForm from "../Components/VerifyProductForm";
import { mergeProduct, rejectProduct } from "../Controller/ProductController";
import { loaderStateTrue, loaderStateFalse, handleActiveLink } from '../../../../Actions/AllAction';

import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";

const VerifyStockTransfer = (props) => {
    const { slack } = useParams();
    const [stockTransfer, setStockTransfer] = useState(null);
    const [productTransferSlack, setProductTransferSlack] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedProductData, setSelectedProductData] = useState(null);
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [pendingRejectSlack, setPendingRejectSlack] = useState(null);

    const fetchStockTransfer = useCallback(async () => {
        try {
            const response = await getStockTransferDetails(slack);
            if (response.success && response.data) {
                setStockTransfer(response.data);
            } else {
                toast.error('Stock Transfer not found');
            }
        } catch (error) {
            console.error('Error fetching stock transfer:', error);
            toast.error('Failed to fetch stock transfer details');
        }
    }, [slack]);

    // Fetch stock transfer data based on ID
    useEffect(() => {
        fetchStockTransfer();
    }, [fetchStockTransfer]);

    // submit product merge
    const handleVerifyProduct = async (data) => {
        props.loaderStateTrue();
        try {
            const mergeData = {
                stock_transfer_slack: productTransferSlack,
                store_product_slack: data?.product?.value || "",
                accepted_quantity: data.quantity.toFixed(2),
                uom_id: data?.uom_id || null,
                unit_of_measure: data?.unit_of_measure || null,
                damaged_quantity: data.damaged_quantity ? parseFloat(data.damaged_quantity).toFixed(2) : 0,
                damaged_uom_id: data?.damaged_uom_id || null,
                damaged_unit_of_measure: data?.damaged_unit_of_measure || null,
                damage_cause: data.damage_cause || 'TRANSIT_DAMAGE',
                damage_notes: data.damage_notes || '',
                auto_create_wastage: data.auto_create_wastage !== false,
                update_purchase_cost: !!data?.update_purchase_cost,
                ...(data?.conversion_factor ? {
                    conversion_factor: data.conversion_factor,
                } : {}),
                store_id: localStorage.getItem("store_id")
            };
            // console.log("the data", mergeData);
            const response = await mergeProduct(mergeData);
            // return;
            if (response.success) {
                // Show success message
                Utility.toastNotifications(response?.message || 'Product merged successfully', 'Success', 'success');

                // Close modal
                setModalVisible(false);

                // Reset states
                setProductTransferSlack(null);
                setSelectedProductData(null);

                // Refresh data
                await fetchStockTransfer();
            } else {
                Utility.toastNotifications(response?.message || 'Failed to merge product', 'Error', 'error');
            }
        } catch (e) {
            setModalVisible(false);
            setProductTransferSlack(null);
            setSelectedProductData(null);

            console.error('Error verifying stock transfer:', e);
            Utility.toastNotifications('An error occurred while merging a product', 'Error', 'error');
        } finally {
            props.loaderStateFalse();
        }
    }

    const confirmationModalForReject = (slack) => {
        setPendingRejectSlack(slack)
        setShowRejectModal(true)
    }

    const closeRejectModal = () => {
        setShowRejectModal(false)
        setPendingRejectSlack(null)
    }

    const confirmRejectModal = async () => {
        closeRejectModal()
        await handleRejectProduct(pendingRejectSlack)
    }

    // reject product transfer
    const handleRejectProduct = async (slack) => {
        try {
            const response = await rejectProduct(slack);

            if (response.success) {
                Utility.toastNotifications('Product rejected successfully', 'Success', 'success');
                await fetchStockTransfer();
            } else {
                Utility.toastNotifications(response?.message || 'Failed to reject product', 'Error', 'error');
            }
        } catch (e) {
            console.error('Error rejecting product:', e);
            Utility.toastNotifications('An error occurred while rejecting a product', 'Error', 'error');
        }
    }

    const handleModalCancel = () => {
        if (!props.loaderState) {
            setModalVisible(false);
            setProductTransferSlack(null);
            setSelectedProductData(null);
        }
    }

    if (!stockTransfer) {
        return (
            <Container fluid className="p-0">
                <div className="text-center py-5">
                    <p>Loading stock transfer details...</p>
                </div>
            </Container>
        );
    }

    const userType = props?.userCredentials?.user_details?.user_type || props?.userCredentials?.user_type;
    const isAdminUser = userType === 'admin' || userType === 'app_admin' || props?.userCredentials?.user_details?.is_super_admin === 1 || props?.userCredentials?.is_super_admin === 1;
    const toStoreId = Number(stockTransfer.to_store_id || stockTransfer.StockTransfer_ToStore?.id || 0);
    const currentStoreId = Number(props.currentStore?.id || localStorage.getItem('store_id') || 0);
    const isToStore = currentStoreId > 0 && currentStoreId === toStoreId;

    //======= add action permission ====//
    // Check multiple permissions at once
    const stockTransferVerifyAcceptPermissions = Utility.hasMultipleActionPermissions(
        'stock',
        'stock_transfer',
        ['view', 'create', 'edit', 'delete', 'export', 'approve', 'receive', 'verify', 'reject', 'verify_accept'],
        userType || ['admin', 'app_admin']
    );

    return (
        <>
            <Container fluid className="p-0">
                <Row className="mb-0">
                    <Col>
                    </Col>
                    <Col xs="auto" className="d-flex align-items-center">
                        <Link to={`/${localStorage.getItem('i18nextLng') || 'en'}/stock/transfer`} className="btn btn-outline-secondary me-2">
                            <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                            Back to List
                        </Link>
                    </Col>
                </Row>

                <Row>
                    <Col lg={12} className="mb-4">
                        <Card className="custom-border-light h-100">
                            <Card.Body>
                                <Row className={'mb-4'}>
                                    <Col md={11}>
                                        <h2 className="text-title">Verify Stock
                                            Transfer <b>#{stockTransfer.stock_transfer_reference}</b></h2>
                                    </Col>
                                    <Col md={2} className="text-end">
                                        {Number(stockTransfer.status) === 0 && <Badge bg='secondary'>Pending</Badge>}
                                        {Number(stockTransfer.status) === 1 && <Badge bg='info'>Initiated</Badge>}
                                        {Number(stockTransfer.status) === 3 && <Badge bg='warning' className='text-dark'>Dispatched</Badge>}
                                        {Number(stockTransfer.status) === 2 && <Badge bg='success'>Verified</Badge>}
                                        {![0, 1, 2, 3].includes(Number(stockTransfer.status)) && (
                                            <Badge bg='light' className='text-dark'>{stockTransfer?.StockTransfer_status_data?.label || 'Unknown'}</Badge>
                                        )}
                                    </Col>
                                </Row>

                                <Row className={'mb-4'}>
                                    <Col md={3}>
                                        <p className="mb-2 fw-medium">Source Store</p>
                                        <p className="text-muted mb-0">{stockTransfer.from_store_name}</p>
                                    </Col>
                                    <Col md={3}>
                                        <p className="mb-2 fw-medium">Destination Store</p>
                                        <p className="text-muted mb-0">{stockTransfer.to_store_name}</p>
                                    </Col>
                                    <Col md={3}>
                                        <p className="mb-2 fw-medium">Created By</p>
                                        <p className="text-muted mb-0">{stockTransfer.StockTransfer_CreatedUser.first_name} {stockTransfer.StockTransfer_CreatedUser.last_name}</p>
                                    </Col>
                                    <Col md={3}>
                                        <p className="mb-2 fw-medium">Updated By</p>
                                        <p className="text-muted mb-0">{stockTransfer.StockTransfer_UpdatedUser.first_name} {stockTransfer.StockTransfer_UpdatedUser.last_name}</p>
                                    </Col>
                                </Row>

                                <Row className={'mb-4'}>
                                    <Col md={3}>
                                        <p className="mb-2 fw-medium">Created On</p>
                                        <p className="text-muted mb-0">{Utility.get12HourFormat(stockTransfer.createdAt) || '-'}</p>
                                    </Col>
                                    <Col md={3}>
                                        <p className="mb-2 fw-medium">Updated On</p>
                                        <p className="text-muted mb-0">{Utility.get12HourFormat(stockTransfer.updatedAt) || '-'}</p>
                                    </Col>
                                </Row>

                                <h2 className="text-headline">Product Information</h2>

                                <div className="mt-4">
                                    {stockTransfer.transfer_products.map((el, i) => (
                                        <Row key={el.id} className="mt-4 align-items-end">
                                            <Col md={2}>
                                                <Form.Group>
                                                    <Form.Label>Source Store Product Code</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={el.product_code}
                                                        disabled={true}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={4}>
                                                <Form.Group>
                                                    <Form.Label>Name & Description</Form.Label>
                                                    <div className="d-flex align-items-center">
                                                        <Form.Control type="text" value={el.product_name} disabled />
                                                        {!el.to_store_product && (
                                                            <Badge bg="success" className="ms-2">New</Badge>
                                                        )}
                                                    </div>
                                                </Form.Group>
                                            </Col>

                                            <Col md={3}>
                                                <Form.Group>
                                                    <Form.Label>Transferred Quantity</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        disabled={true}
                                                        value={`${Number(el.quantity) || el.quantity || 0} ${el.unit_of_measure || el.Product?.unit_of_measure || ''}`.trim()}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={3}>
                                                {el.status === 0 ? <>
                                                    {isToStore &&
                                                        <>
                                                            {(stockTransferVerifyAcceptPermissions.verify_accept || isAdminUser) && (
                                                                <Button
                                                                    variant="outline-primary"
                                                                    onClick={() => {
                                                                        const uom = el.unit_of_measure || el.Product?.unit_of_measure || '';
                                                                        // Open the verify product modal for all products (new or existing)
                                                                        setProductTransferSlack(el.slack);
                                                                        setSelectedProductData({
                                                                            quantity: el.quantity,
                                                                            unit_of_measure: uom,
                                                                            uom_id: el.uom_id || el.Product?.base_uom_id || null,
                                                                            uom_mappings: el.uom_mappings || [],
                                                                            to_store_product: el.to_store_product || el.DestinationProduct || null,
                                                                            product_name: el.product_name || el.Product?.name || '',
                                                                            product_code: el.product_code || el.Product?.product_code || ''
                                                                        });
                                                                        setModalVisible(true);
                                                                    }}
                                                                    disabled={props.loaderState}
                                                                >
                                                                    Verify & Accept
                                                                </Button>
                                                            )}
                                                            {(stockTransferVerifyAcceptPermissions.reject || isAdminUser) && (
                                                                <Button
                                                                    className={'ms-2'}
                                                                    variant="danger"
                                                                    onClick={(e) => {
                                                                        e.preventDefault()
                                                                        e.stopPropagation()
                                                                        confirmationModalForReject(el.slack)
                                                                    }}
                                                                    disabled={props.loaderState}
                                                                >
                                                                    Reject
                                                                </Button>
                                                            )}
                                                        </>
                                                    }
                                                </> : <Badge
                                                    bg={el.status_data?.value_constant === 'REJECTED' ? 'danger' : 'success'}
                                                    className={el.status_data?.color || ''}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    {el.status_data?.label || 'Accepted'}
                                                </Badge>}
                                            </Col>
                                        </Row>
                                    ))}
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <ModalGlobal
                show={modalVisible}
                onHide={handleModalCancel}
                className="modalcustomize confirmationalertmodal"
                bodyClassName="cancelConfirmationbody"
                headerclassName="close_btn_icon"
                title="Verify product"
                footer={false}
                backdrop={props.loaderState ? 'static' : true}
                keyboard={!props.loaderState}
                body={
                    <ConfirmationAlert
                        BodyFirstContent={
                            <VerifyProductForm
                                key={productTransferSlack}
                                onSubmit={handleVerifyProduct}
                                onCancel={handleModalCancel}
                                initialQuantity={selectedProductData?.quantity}
                                productData={selectedProductData}
                                loading={props.loaderState}
                            />
                        }
                        BodySecondContent=""
                        BodyThirdContent=""
                        confirmationButtonContent='confirm'
                        cancelButtonContent='cancel'
                        saveShow={false}
                        cancelShow={false}
                    />
                }
            />

            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={showRejectModal}
                    onHide={closeRejectModal}
                    className="modalcustomize confirmationalertmodalDialog"
                    bodyClassName="cancelConfirmationbody"
                    headerclassName="close_btn_icon"
                    title="Confirm Reject Product"
                    footer={false}
                    body={
                        <>
                            <ErrorBoundary title="ConfirmationAlert Error">
                                <ConfirmationAlert
                                    BodyFirstContent="Are you sure you want to reject this product?"
                                    BodySecondContent=""
                                    BodyThirdContent=""
                                    confirmationButtonContent="Yes"
                                    cancelButtonContent="No"
                                    deleteConfirmButton={confirmRejectModal}
                                    deleteCancleButton={closeRejectModal}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>
        </>
    );
};

const mapStateToProps = (globalState) => ({
    userCredentials: globalState.LoginReducer.userCredentials,
    userEntryType: globalState.LoginReducer.userEntryType,
    currentStore: globalState.StoreReducer.currentStore,
    loaderState: globalState.mainReducerData.loaderState,
});

export default connect(mapStateToProps, {
    loaderStateTrue,
    loaderStateFalse,
    handleActiveLink
})(withNamespaces()(VerifyStockTransfer));
